import { render, staticRenderFns } from "./MasterPlate.vue?vue&type=template&id=c9892dae&scoped=true&"
import script from "./MasterPlate.vue?vue&type=script&lang=js&"
export * from "./MasterPlate.vue?vue&type=script&lang=js&"
import style0 from "./MasterPlate.vue?vue&type=style&index=0&id=c9892dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9892dae",
  null
  
)

export default component.exports